module.exports = __webpack_public_path__ + "media/images/vp/slider.index.04-317ec96e6d962bbbd120e5cf47538bb5.jpg";